import { Component, OnInit, OnDestroy } from '@angular/core';
import { Idioma } from 'shared/entities/idioma.entity';
import { IdiomaService } from '../services/idioma.service';
import { NavegacaoPaginaService } from '../services/navegacaopagina.service';
import { Subscription } from 'rxjs';
import { PlataformaService } from 'projects/cliente/src/app/services/plataforma.service';
import { ParametroService } from '../services/parametro.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {


  public Idiomas: Idioma[] = null;
  public TrocarSenha: boolean = false;
  public Confirmacao: boolean=false;
  private subscription: Subscription = new Subscription();
  public LinkInformacaoLegal:string= null;
  public PossuiInformacoesLegal: boolean = false;

  constructor(private srvIdioma: IdiomaService, private srvNavegacao: NavegacaoPaginaService, private srvPlataforma: PlataformaService,
    private srvParametro: ParametroService) {
    this.LinkInformacaoLegal = this.srvPlataforma.RetornarLinkInformacaoLegal();
   }

  ngOnInit(): void {
    this.srvPlataforma.PossuiInformacaoLegal().subscribe(d=>this.PossuiInformacoesLegal = d);
    /*this.srvParametro.Retornar(77).subscribe(d=>
      {
        if (d)
          this.srvNavegacao.TextoConfirmacao = d.Valor;
      })*/
    this.srvIdioma.Listar(null)
      .subscribe(d => {
        this.Idiomas = d.Lista;
      });
    this.subscription.add(this.srvNavegacao.alterarSenha$.subscribe(d => {
      this.TrocarSenha = d;
    }))
    this.subscription.add(this.srvNavegacao.confirmarInternetBanking$.subscribe(d => {
      this.Confirmacao = d;
    }))
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
